<template>
  <b-modal :id="lModalId" ref="error-modal" ok-only>
    <b-container>
      <b-row class="justify-content-center">
        <div class="error-container">
          <div class="error-container--outter-circle">
            <div class="error-container--inner-circle">
              <i class="error-container--icon fas fa-exclamation"></i>
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="justify-content-center mt-5">
        <h2>
          {{ $props.title }}
        </h2>
      </b-row>
      <b-row class="justify-content-center mt-3">
        <slot name="description"> </slot>
      </b-row>
    </b-container>
    <template #modal-footer>
      <b-button
        @click="onActioHandler(false)"
        variant="outline-primary"
        v-show="$props.cancelButtonText"
      >
        {{ $props.cancelButtonText ? $props.cancelButtonText : "Voltar" }}
      </b-button>

      <b-button @click="onActioHandler(true)" class="ml-4" variant="primary">
        {{ $props.submitButtonText ? $props.submitButtonText : "Confirmar" }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: [
    "title",
    "modalId",
    "description",
    "buttonText",
    "cancelButtonText",
    "submitButtonText",
    "onAction",
  ],
  setup(props, ctx) {
    const lModalId = props.modalId ? props.modalId : "error-modal";

    const closeModal = function() {
      ctx.refs["error-modal"].hide();
    };

    const onActioHandler = function(event) {
      if (props.onAction) {
        props.onAction(event);
      }
      closeModal();
    };

    return { lModalId, onActioHandler };
  },
};
</script>

<style lang="scss" scoped>
.error-container {
  &--icon {
    font-size: 4rem;
    color: white;
  }

  &--inner-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 7rem;
    width: 7rem;
    background: var(--danger-1);
    border-radius: 100%;
  }

  &--outter-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 9rem;
    width: 9rem;
    background: var(--danger-0);
    border-radius: 100%;
  }
}
</style>
